// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3Ioxt","footer":"ChangeClinic_footer__1tXkj"};